import { Outlet, useLocation, useNavigate } from 'react-router-dom';

import { DialogID, useDialog } from '@components/Dialog';
import { ErrorIndicator } from '@components/ErrorIndicator';
import { Layout } from '@components/Layout';
import { paths } from '@constants/paths';
import { EnergyProvider } from '@features/Energy/Provider';
import { useEnergyContext } from '@features/Energy/Provider';
import { usePageStateHandler } from '@hooks/usePageStateHandler';
import { withProfiler } from '@services/sentry/withProfiler';

const PAGE_TITLE = 'Energy';

const EnergyOutlet = () => {
  const navigate = useNavigate();
  const { basketRaw, isBasketLoading, basketError, isDetailsFormChanged } =
    useEnergyContext();
  const { pathname } = useLocation();
  const saveChangesDialog = useDialog(DialogID.SAVE_CHANGES_ENERGY);

  const handleBack = () => {
    if (pathname === paths.energy) {
      return navigate(paths.bundle);
    }

    if (isDetailsFormChanged) {
      saveChangesDialog.setOpen(true);
      return;
    }

    return navigate(paths.energy);
  };

  const { isLoading, hasError } = usePageStateHandler({
    loading: isBasketLoading,
    hasData: !!basketRaw,
    error: basketError,
  });

  if (isLoading) {
    return null;
  }

  if (hasError) {
    return (
      <Layout
        title={PAGE_TITLE}
        onBack={handleBack}
        backButtonLabel="Back to bundle"
      >
        <ErrorIndicator />
      </Layout>
    );
  }

  return (
    <Layout
      title={PAGE_TITLE}
      onBack={handleBack}
      backButtonLabel="Back to bundle"
    >
      <Outlet />
    </Layout>
  );
};

const EnergyProviderUnwrapped = () => (
  <EnergyProvider>
    <EnergyOutlet />
  </EnergyProvider>
);

const Energy = withProfiler(EnergyProviderUnwrapped);

export { Energy };
